import { createAction } from "redux-actions";

import type { SyncStatusAction } from "../types";

export const UpdateSyncStatus = "UpdateSyncState";
export const updateSyncStatus =
  createAction<SyncStatusAction>(UpdateSyncStatus);
